import React, { useEffect, useRef, useState } from 'react';
import "./PanelListDefault.css";
import GridItemDefault from './GridItemDefault';
import NoDataFolder from "../../Components/SideBar/assets/icons/no-data-folder.png"
import LoadingIndicator from '../LoadingIndicator/LoadingIndicator';
import FormatAttribute from '../FormatAttribute/FormatAttribute';
import userImage from './Icons/do-utilizador.png';
import iaImage from './Icons/assistente-de-robo (1).png';

const PanelListDefault = (
    { onUpdateIdSelected,
        idsSelected,
        data,
        style,
        attributeList,
        readOnlyModal,
        disableModal = false,
        loadingIndicatorIds,
        isEmptyPanel = false,
        selectFirstRecord = false,
        inserting,
        updating

    }) => {
    const [multipleRecordsCheckedCheckbox, setMultipleRecordsCheckedCheckbox] = useState(false);
    const [idShowBalloon, setIdShowBalloon] = useState(null);
    const balloonIdRef = useRef([]);

    useEffect(() => {
        if (
            idsSelected && idsSelected.length === 0 &&
            data && data[0] && data[0].constructorList &&
            selectFirstRecord &&
            !inserting && !updating
        ) {
            const idField = data[0].constructorList.find(attr => attr.field === 'id');
            if (idField && idField.argument) {
                onUpdateIdSelected([idField.argument]);
            }
        }
    }, [data]);

    const handleMouseOver = (key) => {
        if (!key) {
            return false;
        }

        balloonIdRef.current.push(key);

        setTimeout(() => {
            if (balloonIdRef.current.length === 1 && balloonIdRef.current[0] === key) {
                setIdShowBalloon(key);
                balloonIdRef.current = [];
            }
        }, 1500);
    };

    const handleMouseOut = () => {
        balloonIdRef.current = [];
        setIdShowBalloon(null);
    };

    useEffect(() => {
        setMultipleRecordsCheckedCheckbox((
            idsSelected && idsSelected.length > 0)
            && (data && data.length > 0)
            && idsSelected.length === data.length);
    }, [idsSelected])

    let isEmpty = isEmptyPanel;
    if (!isEmpty && data && data.length === 1) {
        const constructorList = data[0].constructorList;
        isEmpty = constructorList.every(item =>
            (item.argument === "" || item.argument === null)
        );
    }

    let rowsList;
    if (data && data.length === 1 && data[0].constructorList.every(item => item.argument === '' || item.argument === null)) {
        rowsList = null;
    } else if (data && data.length > 0) {
        rowsList = data.map((row, index) => (
            getAttributeRowList(row, index, readOnlyModal, loadingIndicatorIds)
        ));
    }

    function getAttributeRowList(row, index, readOnlyModal, loadingIndicatorIds) {
        if (row && row.constructorList) {
            const rowSortedAttributes = row.constructorList.sort(
                (a, b) => a.presentationSequence - b.presentationSequence
            );
            return (
                <div className="user-row register" key={index} style={styleRowPanelList(index)}>
                    {
                        rowSortedAttributes.map((attribute) => (
                            getDivAttribute(attribute, row.id, readOnlyModal, enableLoaderIndicator(loadingIndicatorIds, attribute))
                        ))
                    }
                </div>
            )
        }
    }

    function styleRowPanelList(index) {
        return {
            backgroundColor: index % 2 === 0 ? 'white ' : 'rgb(248 248 248)',
            Zindex: 0
        };
    }

    function getDivAttribute(attribute, rowId, readOnlyModal, enableLoaderIndicator) {
        const valueToDisplay = attribute.argument;
        const isGridAttribute = attribute.labelGrid;
        const attributeField = attribute.field;
        const mask = attribute.mask;
        const presentationSequence = attribute.presentationSequence;
        const textColor = attribute.additionalParametersDTO ? attribute.additionalParametersDTO.textColor : null;
        let attributeDataFrontend;
        if (attributeList) {
            attributeDataFrontend = attributeList.find(obj => validateIfSameAttribute(obj.name, attributeField)) || {};
        }

        let allowsMultipleRecordsSelected

        if (attributeDataFrontend) {
            allowsMultipleRecordsSelected = attributeDataFrontend.allowsMultipleRecordsSelected
        }

        if (!isGridAttribute) {
            return null;
        }

        if (attributeDataFrontend && (attributeDataFrontend.isVisible === 'N' || attributeDataFrontend.isVisible === false)) {
            return null;
        }

        if (attribute.argumentAdvanced && Array.isArray(attribute.argumentAdvanced)) {
            const uniqueKey = `${attribute.field}-${attribute.presentationSequence}`;

            return (
                <div
                    className="cell"
                    key={uniqueKey}
                    style={{
                        color: attributeDataFrontend?.textColor || 'inherit',
                        cursor: attributeDataFrontend?.cursor || 'default',
                        whiteSpace: (attributeDataFrontend && attributeDataFrontend.whiteSpace ? attributeDataFrontend.whiteSpace : 'nowrap'),
                        maxWidth: (attributeDataFrontend && attributeDataFrontend.maxGridWidth ? attributeDataFrontend.maxGridWidth : '250px'),
                        minWidth: (attributeDataFrontend && attributeDataFrontend.minGridWidth ? attributeDataFrontend.minGridWidth : '100%')
                    }}
                >
                    <LoadingIndicator loaded={enableLoaderIndicator} style={{ width: '35px', height: '35px' }}>

                        {attribute.argumentAdvanced.map((subAttribute, index) => {
                            const valueToDisplay = subAttribute.argument
                            const isGridAttribute = subAttribute.labelGrid
                            const attributeField = subAttribute.field
                            const mask = subAttribute.mask

                            let attributeDataFrontend = {};
                            if (attributeList) {
                                attributeDataFrontend = attributeList.find(obj => validateIfSameAttribute(obj.name, attributeField)) || {};
                            }

                            let setterFrontend
                            let valueFrontend
                            let allowsMultipleRecordsSelected

                            if (attributeDataFrontend) {
                                setterFrontend = attributeDataFrontend.setter
                                valueFrontend = attributeDataFrontend.value
                                allowsMultipleRecordsSelected = attributeDataFrontend.allowsMultipleRecordsSelected
                            }


                            if (!isGridAttribute) {
                                return null
                            }

                            if (attributeDataFrontend &&  (attributeDataFrontend.isVisible === 'N' || attributeDataFrontend.isVisible === false)) {
                                return null
                            }

                            let disabled = disableModal
                            if (attributeDataFrontend.disabledAttributoToValidate && !disabled) {
                                const argumentToValidateDisabled = attribute.argumentAdvanced.find(
                                    attr => attr.field === attributeDataFrontend.disabledAttributoToValidate
                                );

                                if (argumentToValidateDisabled && argumentToValidateDisabled.argument) {
                                    disabled = true;
                                }
                            }

                            const dataText = getTypeData(
                                attributeDataFrontend,
                                attribute,
                                subAttribute,
                                readOnlyModal,
                                attributeField,
                                valueToDisplay,
                                mask,
                                setterFrontend,
                                valueFrontend,
                                allowsMultipleRecordsSelected,
                                disabled);

                            const uniqueKey = `${subAttribute.field}-${attribute.presentationSequence}`;

                            return (
                                <div className="cell" key={uniqueKey}
                                    onClick={getOnClickFunction(attributeDataFrontend, valueToDisplay, attributeDataFrontend.setter)}
                                    style={{
                                        minWidth: (attributeDataFrontend && attributeDataFrontend.minGridWidth ? attributeDataFrontend.minGridWidth : '100%'),
                                        maxWidth: (attributeDataFrontend && attributeDataFrontend.maxGridWidth ? attributeDataFrontend.maxGridWidth : '250px'),
                                        whiteSpace: (attributeDataFrontend && attributeDataFrontend.whiteSpace ? attributeDataFrontend.whiteSpace : 'nowrap'),
                                        ...attributeDataFrontend.styleGrid
                                    }}
                                    onDoubleClick={getOnDoubleClickFunction(attributeDataFrontend)}
                                    onMouseOver={() => handleMouseOver(subAttribute.id)}
                                    onMouseOut={() => handleMouseOut()}
                                >
                                    {(1 == 0 && idShowBalloon && dataText && idShowBalloon === subAttribute.id) && <div className="balloon-panel-list">{dataText}</div>}
                                    {dataText}
                                </div>
                            );
                        })}
                    </LoadingIndicator>
                </div>
            );
        }

        const dataText = getTypeData(attributeDataFrontend,
            attribute,
            attribute,
            readOnlyModal,
            attributeField,
            valueToDisplay,
            mask,
            onUpdateIdSelected,
            idsSelected,
            allowsMultipleRecordsSelected,
            disableModal)

        const uniqueKey = `${attribute.field}-${attribute.presentationSequence}`;

        return (
            <div className="cell"
                key={uniqueKey}
                style={{
                    minWidth: (attributeDataFrontend && attributeDataFrontend.minGridWidth ? attributeDataFrontend.minGridWidth : '100%'),
                    maxWidth: (attributeDataFrontend && attributeDataFrontend.maxGridWidth ? attributeDataFrontend.maxGridWidth : '250px'),
                    textColor,
                    cursor: (attributeDataFrontend && attributeDataFrontend.cursor) ? attributeDataFrontend.cursor : 'default',
                    whiteSpace: (attributeDataFrontend && attributeDataFrontend.whiteSpace ? attributeDataFrontend.whiteSpace : 'nowrap'),
                    ...attributeDataFrontend.styleGrid
                }}
                onClick={getOnClickFunction(attributeDataFrontend, rowId, onUpdateIdSelected)}
                onDoubleClick={getOnDoubleClickFunction(attributeDataFrontend)}
                onMouseOver={() => handleMouseOver(attributeField)}
                onMouseOut={() => handleMouseOut()}
            >
                {(1 == 0 && idShowBalloon && dataText && idShowBalloon == attributeField) && <div className="balloon-panel-list">{dataText}</div>}
                {dataText}
            </div>
        );
    }

    function enableLoaderIndicator(loadingIndicatorIds, cell) {
        if (!loadingIndicatorIds || loadingIndicatorIds.length === 0) {
            return true;
        }

        if (cell?.argumentAdvanced?.length) {
            const idArgument = cell.argumentAdvanced.find(
                (arg) => arg.labelGrid === 'ID'
            )?.argument;

            if (idArgument !== undefined) {
                return !loadingIndicatorIds.includes(idArgument)
            }
        }

        return true;
    }


    function validateIfChecked(attribute, checks) {
        if (!checks) {
            return false;
        }

        let trueChecks = [];

        for (const check of checks) {
            if (conditionsIsTrue(attribute, check)) {
                trueChecks.push(true);
            }
            if (Array.isArray(attribute.argumentAdvanced) && checks.length !== trueChecks.length) {
                for (const advancedAttribute of attribute.argumentAdvanced) {
                    if (conditionsIsTrue(advancedAttribute, check)) {
                        trueChecks.push(true);
                    }
                }
            }
        }

        return checks.length === trueChecks.length;
    }


    function conditionsIsTrue(attribute, check) {
        if (check.field !== attribute.field) {
            return false
        }

        if (check.condition === 'NOT_NULL' && !attribute.argument) {
            return false;
        }

        if (check.condition === 'VALUE_EQUALS' && check.arrayValue.length > 0 && !check.arrayValue.includes(attribute.argument)) {
            return false;
        }
        return true;
    }

    function getOnClickFunction(attributeDataFrontend, rowId, updateValue) {
        return (() => {
            if (!attributeDataFrontend || (attributeDataFrontend && !attributeDataFrontend.ignoreResetSelectRow)) {
                if (rowId) {
                    if ((idsSelected[0] !== rowId)) {
                        updateValue([rowId])
                    }
                }
            }
            if (attributeDataFrontend && attributeDataFrontend.onClick) {
                attributeDataFrontend.onClick()
            }
        })
    }

    function getOnDoubleClickFunction(attributeDataFrontend) {
        return (() => {
            if (attributeDataFrontend && attributeDataFrontend.onDoubleClick) {
                attributeDataFrontend.onDoubleClick()
            }
        })
    }


    function getTypeData(attributeDataFrontend, fatherAttribute, attribute, readOnlyModal, attributeField, valueToDisplay, mask, updateFunction, selectedsValues, allowsMultipleRecordsSelected, disabled = false) {
        if (isCheckbox(updateFunction, attribute)) {
            if (!valueToDisplay) {
                return null
            }
            const isReadOnly = getIfReadOnlyChecks(readOnlyModal, fatherAttribute, attributeDataFrontend)
            return (
                <input
                    style={{ cursor: !isReadOnly ? 'pointer' : 'default' }}
                    type="checkbox"
                    className='checkbox-row-default'
                    id={`checkbox-users-id`}
                    disabled={disabled}
                    onChange={(!isReadOnly && (!attributeDataFrontend || !attributeDataFrontend.readOnlyPanelList)) ? (event) => handleCheckboxChange(event, valueToDisplay, selectedsValues, updateFunction, allowsMultipleRecordsSelected, attributeDataFrontend) : undefined}
                    checked={getIfChecked(fatherAttribute, attributeDataFrontend, selectedsValues, valueToDisplay)}
                />
            )
        } else if (attributeField === 'textColor') {
            return (
                <div
                    style={{
                        width: '15px',
                        height: '15px',
                        borderRadius: '50%',
                        display: 'inline-block',
                        cursor: 'pointer',
                        backgroundColor: valueToDisplay
                    }}
                ></div>
            )
        } else if (attribute.columnType === 'icon') {
            return (
                <img
                    src={attributeDataFrontend.argument === 'R' ? iaImage : userImage}
                    alt="icon"
                    style={{
                        width: '16px',
                        height: '16px',
                        objectFit: 'contain'
                    }}
                />
            )
        } else {
            return (
                FormatAttribute.formatAttribute(
                    valueToDisplay,
                    mask,
                    true,
                    (attributeDataFrontend && attributeDataFrontend.minimumFractionDigits ? attributeDataFrontend.minimumFractionDigits : null))
            )
        }
    }


    function getIfChecked(fatherAttribute, attributeDataFrontend, selectedsValues, valueToDisplay) {
        if (attributeDataFrontend && attributeDataFrontend.checks && validateIfChecked(fatherAttribute, attributeDataFrontend.checks)) {
            return true
        } else if (attributeDataFrontend && attributeDataFrontend.checkArgument && fatherAttribute.argument == 'S') {
            return true
        } else if (selectedsValues.includes(valueToDisplay) && fatherAttribute.argument != 'S' && (!attributeDataFrontend || !attributeDataFrontend.checks)) {
            return true
        }
        return false
    }

    function getIfReadOnlyChecks(readOnlyModal, fatherAttribute, attributeDataFrontend) {
        if (readOnlyModal) {
            return true
        }

        if (attributeDataFrontend && attributeDataFrontend.readOnlyChecks && validateIfChecked(fatherAttribute, attributeDataFrontend.readOnlyChecks)) {
            return true
        }

        if (attributeDataFrontend && attributeDataFrontend.readOnlyGrid) {
            return true
        }

        return false
    }

    function isCheckbox(updateFunction, attribute) {
        return (attribute && attribute.columnType && (attribute.columnType.toUpperCase() === 'CHECKBOX') && updateFunction);
    }

    const handleCheckboxChange = (event, keyValidated, selectedsValues, updateFunction, allowsMultipleRecordsSelected, attributeDataFrontend) => {
        if (allowsMultipleRecordsSelected === true) {
            if (event.target.checked) {
                updateFunction([...selectedsValues, keyValidated]);
            } else {
                updateFunction(selectedsValues.filter(id => id !== keyValidated));
            }
        } else if (attributeDataFrontend && attributeDataFrontend.differentiatedCheckboxAlwaysArgument) {
            updateFunction([keyValidated]);
        } else {
            if (event.target.checked) {
                updateFunction([keyValidated]);
            } else {
                updateFunction([]);
            }
        }
    };

    function validateIfSameAttribute(attr1, attr2) {
        if (!attr1 || !attr2) {
            return false;
        }

        if (attr1.toUpperCase() === attr2.toUpperCase()) {
            return true;
        }
        return false;
    }

    let panelEmpty
    if (isEmpty) {
        panelEmpty = (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                height: 'calc(100% - 43px)'
            }}>
                <img src={NoDataFolder} alt="Sem dados" style={{
                    width: '125px',
                    marginBottom: '20px'
                }} />
                <span style={{
                    fontSize: '1.2rem',
                    color: '#555'
                }}>Nenhum resultado encontrado.</span>
            </div>
        )
    }

    return (
        <>
            <div id='panel-list' style={style}>
                <div className="scrollable-content">
                    <div className="user-table">
                        <div className="user-row header first" style={{ height: '43px' }}>
                            <GridItemDefault.RenderGridItems
                                items={data}
                                attributeList={attributeList}
                                onUpdateIdSelected={onUpdateIdSelected}
                                idsSelected={idsSelected}
                                setMultipleRecordsCheckedCheckbox={setMultipleRecordsCheckedCheckbox}
                                multipleRecordsCheckedCheckbox={multipleRecordsCheckedCheckbox}
                                readOnlyModal={readOnlyModal}
                                disableModal={disableModal}
                            />
                        </div>
                        <div className="user-row header" style={{ top: '33px' }}>
                            <GridItemDefault.RenderSecondGridItems
                                items={data}
                            />
                        </div>
                        {rowsList}
                    </div>
                    {panelEmpty ? panelEmpty : null}
                </div>
            </div>
        </>
    );
}

export default PanelListDefault;
